document.addEventListener("readystatechange", function(event) {
  function rewardLinking() {
    var url_string = window.location;
    var url = new URL(url_string);
    var instance = url.searchParams.get("instance");
    if (instance != null) {
      if (instance === "HISTORY") {
        function historyModal() {
          if (document.body.contains(document.querySelector("button[aria-label='REWARDS HISTORY']"))) {
            var historyBtn = document.querySelector("button[aria-label='REWARDS HISTORY']");
            historyBtn.click();
          } else { setTimeout(() => { historyModal() }, "1000"); }
        };
        historyModal();
      } else { 
        const rewardLocation = document.querySelector(`[yotpo-instance-id='${instance}']`);     rewardLocation.setAttribute("id", "mb-link");
        window.location = "#mb-link";
      }
      var newURL = location.href.split("?")[0];
      window.history.pushState('object', document.title, newURL);
    }
  }
  rewardLinking();
});